import React from "react";

/**
 * Ikona polievky (misa s parou). Farba z CSS (currentColor).
 */
export function SoupIcon({ className, size = 24 }) {
  return (
    <svg
      className={`${className || ""} section-icon--soup`.trim()}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M12 32C12 41.9411 21.0589 50 32 50C42.9411 50 52 41.9411 52 32H12Z"
        fill="currentColor"
      />
      <path
        className="section-icon__steam"
        d="M24 16C24 12 28 12 28 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        className="section-icon__steam"
        d="M36 16C36 12 40 12 40 8"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

/**
 * Ikona hlavného jedla (tanier s príbory). Farba z CSS (currentColor).
 */
export function MealIcon({ className, size = 24 }) {
  return (
    <svg
      className={`${className || ""} section-icon--meal`.trim()}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="32"
        cy="32"
        r="20"
        stroke="currentColor"
        strokeWidth="2"
      />
      <circle cx="32" cy="32" r="8" fill="currentColor" />
      <rect x="10" y="28" width="4" height="16" fill="currentColor" />
      <rect x="50" y="28" width="4" height="16" fill="currentColor" />
    </svg>
  );
}

export default { SoupIcon, MealIcon };
